export default __webpack_public_path__ + "static/media/john-pierson.a6d9e4f8.png";